export const MaskCPF = (cpf) => {
  cpf = cpf.replace(/\D/g, "");
  cpf = cpf.substring(0, 11);
  let string = "";

  for (let i = 0; i < cpf.length; i++) {
    let char = cpf[i];
    if (i === 3 || i === 6) string += "." + char;
    else if (i === 9) string += "-" + char;
    else string += char;
  }

  return string;
};

export const MaskPhone = (phone) => {
  phone = phone.replace(/\D/g, "");
  phone = phone.substring(0, 11);
  let string = "";

  if (phone.length < 11) {
    for (let i = 0; i < phone.length; i++) {
      let char = phone[i];
      if (i === 0) string += "(" + char;
      else if (i === 1) string += char + ") ";
      else if (i === 6) string += "-" + char;
      else string += char;
    }
  } else {
    for (let i = 0; i < phone.length; i++) {
      let char = phone[i];
      if (i === 0) string += "(" + char;
      else if (i === 1) string += char + ")";
      else if (i === 2 || i === 3) string += " " + char;
      else if (i === 7) string += "-" + char;
      else string += char;
    }
  }

  return string;
};

export const MaskCEP = (cep) => {
  cep = cep.replace(/\D/g, "");
  cep = cep.substring(0, 8);
  let string = "";

  for (let i = 0; i < cep.length; i++) {
    let char = cep[i];
    if (i === 5) string += "-" + char;
    else string += char;
  }

  return string;
};
